<template>
    <v-tooltip
        :disabled="shortenedLink.length === link.length"
        max-width="400"
        bottom
    >
        <template v-slot:activator="{ on }">
            <v-btn
                v-on="on"
                class="help-link"
                ref="sidebarValue"
                plain
                text
                color="primary"
                @click.prevent="openLinkInNewTab()"
                :href="fixedLink()"
            >
                <v-img
                    width="15"
                    :src="getFaviconUrl()"
                    :alt="shortenedLink"
                >
                </v-img>
                <span class="pl-2 font-weight-regular">{{ shortenedLink }}</span>
            </v-btn>
        </template>
        <span>{{ link }}</span>
    </v-tooltip>
</template>

<script>
import {ref, onMounted} from "@vue/composition-api";

export default {
    name: "LinkButton",
    props: {
        link: {
            type: String,
            required: true
        },
        hostOnly: {
            type: Boolean,
            default: false
        }
    },
    setup(props) {
        const sidebarValue = ref(null)
        const isOverflowing = ref(false)

         const checkOverflow = () => {
            isOverflowing.value = sidebarValue.value.scrollWidth > sidebarValue.value.clientWidth;
        };

        onMounted(() => {
            setTimeout(() => {
                checkOverflow()
            }, 100)
        });

        const fixedLink = () => {
            let link
            if (props.link.includes("://")) {
                link = props.link
            } else if (props.link.includes(":")) {
                const splittedLink = props.link.split(":")
                link = `${splittedLink[0]}://${splittedLink[1]}`
            } else {
                link = `https://${props.link}`
            }

            return link
        }

        const shortenLink = (link) => {
            if (!link) {
                return link
            }
            const urlObject = new URL(link)

            if (props.hostOnly) {
                return urlObject.hostname
            }
            const showProtocol = urlObject.protocol !== "https:"
            let shortenLink = ""

            const pathnameWithSearch = urlObject.pathname + urlObject.search
            if (pathnameWithSearch && pathnameWithSearch.length > 9) {
                const shortenedPath = pathnameWithSearch.slice(0, 3) + '...' + pathnameWithSearch.slice(-3)
                shortenLink = showProtocol ? urlObject.protocol : ""
                shortenLink = shortenLink + urlObject.hostname + shortenedPath
            } else {
                shortenLink = showProtocol ? urlObject.protocol : ""
                shortenLink = urlObject.hostname + pathnameWithSearch
            }

            return shortenLink

        }

        const shortenedLink = ref(shortenLink(fixedLink()))

        const getFaviconUrl = () => {
            const serviceUrl = 'https://www.google.com/s2/favicons?sz=24&domain_url='
            const link = fixedLink()
            const urlObject = new URL(link)
            const hostUrl = urlObject.host ? urlObject.host : null
            return serviceUrl + hostUrl
        }

        /***
         How to acquire title for link if needed

         const getTitle = async () => {
         const response = await fetch(`/api/link/preview?link=${encodeURIComponent(props.link)}`)
         const responseJson = await response.json()
         if(responseJson && responseJson.success && responseJson.title) {
         shortenedLink.value = responseJson.title
         }

         }
         getTitle()
         ***/

        const openLinkInNewTab = () => {
            window.open(fixedLink(), '_blank')
        }

        return {
            sidebarValue,
            isOverflowing,
            shortenedLink,
            getFaviconUrl,
            openLinkInNewTab,
            fixedLink,
        }
    }

}
</script>
<style scoped>
.v-btn.v-size--default {
    width: auto;
    height: auto;
    padding-left: 12px;
    padding-right: 12px;
}
</style>

